import {
  useChangePasswordMutation,
  useDeleteProfileMutation,
  useEditProfileMutation,
  useFileUploadMutation,
  useGlobalConfigQuery,
  useProfileQuery,
  useMultifileUploadMutation,
  useLazyGetNotificationsQuery,
  useUpdateNotificationStatusMutation,
} from "store/api/profile";
import { fixedCacheKeys } from "utils/fixedCacheKeys";

export const useProfileHook = () => {
  /** ***************** 
  @purpose : Used For handle get and reset data
  @Parameter : {data,reset}
  @Author : INIC
  ***************** */

  const { data: userData, refetch: refetchUserData } = useProfileQuery();
  // forcing the query to always fetch when this component is mounted
  // { refetchOnMountOrArgChange: true }
  const [editProfile, { isLoading: profileLoading }] = useEditProfileMutation({
    fixedCacheKey: fixedCacheKeys.EDIT_PROFILE,
  });

  const [fileUpload] = useFileUploadMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD,
  });
  const [multiFileUpload] = useMultifileUploadMutation({
    fixedCacheKey: fixedCacheKeys.FILE_UPLOAD,
  });

  const { data: globalConfigData, refetch: refetchGlobalConfig } = useGlobalConfigQuery({
    refetchOnMountOrArgChange: true,
  });

  const [changePassword, { isLoading: passwordLoading }] = useChangePasswordMutation({
    fixedCacheKey: fixedCacheKeys.CHANGE_PASSWORD,
  });

  const [deleteProfile, { isLoading: deleteProfileLoading }] = useDeleteProfileMutation({
    fixedCacheKey: fixedCacheKeys.DELETE_PROFILE,
  });

  // const { data: columnTableSettingData } = useGetTableColumnSettingsQuery();
  const [
    getNotificationsList,
    { data: getNotificationsListData, isUninitialized: isGetNotificationsListUninitialized },
  ] = useLazyGetNotificationsQuery({
    fixedCacheKey: fixedCacheKeys.GET_NOTIFICATIONS_LIST,
  });
  const [updateNotificationStatus] = useUpdateNotificationStatusMutation({});

  return {
    changePassword,
    passwordLoading,
    profileLoading,
    userData,
    editProfile,
    fileUpload,
    refetchUserData,
    globalConfigData,
    deleteProfile,
    deleteProfileLoading,
    multiFileUpload,
    getNotificationsList,
    getNotificationsListData,
    isGetNotificationsListUninitialized,
    updateNotificationStatus,
    refetchGlobalConfig,
    // columnTableSettingData,
  };
};
